<div class="message-container">
  @if (messages.length) {
    @for (message of messages; track message) {
      <div
        class="message"
        [class.user-message]="message.role === 'user'"
        [class.assistant-message]="message.role === 'assistant'">
        <!-- Show icon if assistant -->
        <div class="assistant-icon" *ngIf="message.role === 'assistant'">
          <mat-icon>account_circle</mat-icon>
        </div>
        <div class="content-container" [class.user-message]="message.role === 'user'">
          <!-- Content -->
          <div class="message-bubble" data-test-id="response-message">
            <markdown mermaid [data]="message.content[0].text" [mermaidOptions]="mermaidChartingConfig"></markdown>
            <span class="timestamp">{{ message.timestamp | date: 'short' }}</span>
          </div>

          <!-- Show actions if reply is from assistant -->
          <div class="message-actions" *ngIf="!currentTypingMessage && !loading && message.role === 'assistant'">
            <button mat-icon-button matTooltip="Copy" (click)="copyToClipboard(message.content[0].text)">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Create draft from response"
              (click)="draftSection(message.content[0].text)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  } @else {
    <p class="placeholder-text">Prompt response will appear here...</p>
  }

  @if (loading) {
    <div class="message assistant-message">
      <div class="assistant-icon">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="message-bubble">
        <span class="ellipsis"></span>
      </div>
    </div>
  }
  <!-- Display currently typing message -->
  @if (currentTypingMessage && isTyping) {
    <div class="message assistant-message">
      <div class="assistant-icon">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="message-bubble">
        <p>{{ currentTypingMessage.content[0].text }}<span class="cursor">▌</span></p>
        <span class="timestamp">{{ currentTypingMessage.timestamp | date: 'short' }}</span>
      </div>
    </div>
  }
</div>
<div class="spacer"></div>
